import CardsFontScaling from './cards-fonts-scaling';

function getUrlParam(name) {
	var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
	if (results==null){
		return null;
	}
	else {
		return decodeURI(results[1]) || 0;
	}
}

let fontScaling = new CardsFontScaling();

export function checkMediumLength() {
		
	let newCards = document.querySelectorAll('.coins-card');
	let table = document.getElementById('coinTable');
	setTableFont();

	if (newCards.length < 15 && newCards.length > 11) {
		table.classList.remove('lessThanTwentyFive');
		table.classList.add('lessThanFifteen');
	}  

	if (newCards.length < 11 && newCards.length > 3) {
		table.classList.remove('lessThanFifteen');
		table.classList.add('lessThanEleven');
	} 

	if (newCards.length < 4 && newCards.length > 2) {
		table.classList.add('lessThanFour');
		table.classList.remove('lessThanEleven');
		newCards.forEach((el) => {
			el.classList.add('height70Percent');
		});
	} 

	if (newCards.length < 3 && newCards.length > 1) {
		newCards.forEach((el) => {
			el.classList.remove('height70Percent');
			el.classList.add('height60Percent');
		});
	} 

	if (newCards.length < 2 && newCards.length > 0) {
		newCards.forEach((el) => {
			el.classList.remove('height60Percent');
			el.classList.add('height35Percent');
		});
	} 

	if (newCards.length < 1 ) {
		table.classList.remove('lessThanFour');
	} 

	if (newCards.length > 0 && newCards.length < 2) {
		newCards.forEach((el) => {
			el.classList.add('height35Percent');
		});
		table.classList.add('lessThanFour');
	} 

	if (newCards.length > 1 && newCards.length < 3) {
		newCards.forEach((el) => {
			el.classList.remove('height35Percent');
			el.classList.add('height60Percent');
		});
	} 

	if (newCards.length > 2 && newCards.length < 4) {
		newCards.forEach((el) => {
			el.classList.remove('height60Percent');
			el.classList.add('height70Percent');
		});
	} 

	if (newCards.length > 3 && newCards.length < 11) {
		newCards.forEach((el) => {
			el.classList.remove('height70Percent');
		});
		table.classList.remove('lessThanFour');
		table.classList.add('lessThanEleven');
	} 

	if (newCards.length > 10 && newCards.length < 15) {
		table.classList.remove('lessThanEleven');
		table.classList.add('lessThanFifteen');
	} 

	if (newCards.length > 14 && newCards.length < 25) {
		table.classList.remove('lessThanFifteen');
		table.classList.add('lessThanTwentyFive');
	} 

	if (newCards.length > 25) {
		table.classList.remove('lessThanTwentyFive');
	} 

	if (newCards.length > 15) {
		table.classList.remove('lessThanSixteen');
	} else {
		table.classList.add('lessThanSixteen');
	}
}

/**
 * Formats cards layout upon cards length.
 * 
 */
export function checkCardsLength() {

	let newCards = document.querySelectorAll('.coins-card');
	let table = document.getElementById('coinTable');
	setTableFont();

	if (window.innerWidth > 1199) {
		if (newCards.length < 25 && newCards.length > 15) {
			table.classList.add('lessThanTwentyFive');
		}  
	}	
		if (newCards.length < 15 && newCards.length > 11) {
			table.classList.remove('lessThanTwentyFive');
			table.classList.add('lessThanFifteen');
		}  

		if (newCards.length < 11 && newCards.length > 3) {
			table.classList.remove('lessThanFifteen');
			table.classList.add('lessThanEleven');
		} 

		if (newCards.length < 4 && newCards.length > 2) {
			table.classList.add('lessThanFour');
			table.classList.remove('lessThanEleven');
			newCards.forEach((el) => {
				el.classList.add('height70Percent');
			});
		} 

		if (newCards.length < 3 && newCards.length > 1) {
			newCards.forEach((el) => {
				el.classList.remove('height70Percent');
				el.classList.add('height60Percent');
			});
		} 

		if (newCards.length < 2 && newCards.length > 0) {
			newCards.forEach((el) => {
				el.classList.remove('height60Percent');
				el.classList.add('height35Percent');
			});
		} 

		if (newCards.length < 1 ) {
			table.classList.remove('lessThanFour');
		} 

		if (newCards.length > 0 && newCards.length < 2) {
			newCards.forEach((el) => {
				el.classList.add('height35Percent');
			});
			table.classList.add('lessThanFour');
		} 

		if (newCards.length > 1 && newCards.length < 3) {
			newCards.forEach((el) => {
				el.classList.remove('height35Percent');
				el.classList.add('height60Percent');
			});
		} 

		if (newCards.length > 2 && newCards.length < 4) {
			newCards.forEach((el) => {
				el.classList.remove('height60Percent');
				el.classList.add('height70Percent');
			});
		} 

		if (newCards.length > 3 && newCards.length < 11) {
			newCards.forEach((el) => {
				el.classList.remove('height70Percent');
			});
			table.classList.remove('lessThanFour');
			table.classList.add('lessThanEleven');
		} 

		if (newCards.length > 10 && newCards.length < 15) {
			table.classList.remove('lessThanEleven');
			table.classList.add('lessThanFifteen');
		} 

		if (newCards.length > 14 && newCards.length < 25) {
			table.classList.remove('lessThanFifteen');
			table.classList.add('lessThanTwentyFive');
		} 

		if (newCards.length > 25) {
			table.classList.remove('lessThanTwentyFive');
		} 

		if (newCards.length > 15) {
			table.classList.remove('lessThanSixteen');
		} else {
			table.classList.add('lessThanSixteen');
		}		
}

/**
 * Sets coins table font size upon window height.
 * 
 */
export function setTableFont() {
	let step = 1;
	let cardElements = document.querySelectorAll('.coins-card');

	if (window.innerWidth > 1199) {
		if (cardElements.length < 45 && cardElements.length > 36) {
			step = 1;
			fontScaling.setFontSizes(step);
		}

		if (cardElements.length < 37 && cardElements.length > 28) {
			step = 2;
			fontScaling.setFontSizes(step);
		}

		if (cardElements.length < 29 && cardElements.length > 14) {
			step = 3;
			fontScaling.setFontSizes(step);
		}

		if (cardElements.length < 15 && cardElements.length > 3) {
			step = 4;
			fontScaling.setFontSizes(step);
		}

		if (cardElements.length < 4 && cardElements.length > 2) {
			if (window.innerWidth < 1200) {
				step = 'm';
			} else {
				step = 5;
			}
			fontScaling.setFontSizes(step);
		}

		if (cardElements.length < 3 && cardElements.length > 1) {
			if (window.innerWidth < 1200) {
				step = 'm';
			} else {
				step = 6;
			}
			fontScaling.setFontSizes(step);
		}

		if (cardElements.length < 2 && cardElements.length > 0) {
			if (window.innerWidth < 1200) {
				step = 'm';
			} else {
				step = 7;
			}
			fontScaling.setFontSizes(step);
		}
	} else if (window.innerWidth < 1200 && window.innerWidth > 780){
		if (cardElements.length > 15) {
			fontScaling.removeAll();
		}

		if (cardElements.length < 15 && cardElements.length > 3) {
			step = 4;
			fontScaling.setFontSizes(step);
		}

		if (cardElements.length < 4 && cardElements.length > 2) {
			if (window.innerWidth < 1200) {
				step = 'm';
			} else {
				step = 5;
			}
			fontScaling.setFontSizes(step);
		}

		if (cardElements.length < 3 && cardElements.length > 1) {
			if (window.innerWidth < 1200) {
				step = 'm';
			} else {
				step = 6;
			}
			fontScaling.setFontSizes(step);
		}

		if (cardElements.length < 2 && cardElements.length > 0) {
			if (window.innerWidth < 1200) {
				step = 'm';
			} else {
				step = 7;
			}
			fontScaling.setFontSizes(step);
		}
	} else {
		fontScaling.removeAll();
	}
}

window.onload = () => {

  var coinInput = document.getElementById('coinInput');
  var coinHistory = document.getElementById('coinHistory');
  var overlay = document.getElementById('overlay');
  var overlay2 = document.getElementById('overlay2');
  var bettingButton = document.getElementById('bettingButton');
  var historyButton = document.getElementById('historyButton');
  var minimize = document.getElementById('minimize');

  // Replace html with multilang labet text
  $("#citgMiddle").text(LABEL.store.no_of_challenges);
  $("#coinPlayButton").text(LABEL.store.play);
  $("#historyGutter").html('<p>' + LABEL.store.history + '</p>');
  $("#bettingButton").html('<p>' + LABEL.store.betting + '</p>');
  $("#coinInputTopGutter").html('<p>' + LABEL.store.betting + '</p>');

  // Determine either back button should be present or not
  getUrlParam('backUrl') ? $('.go-back-btn').css('display', 'flex') : 
	$('.go-back-btn').css('display', 'none');
		
	$("#nav-icon1").click(function (e) {
		e.preventDefault();
		$("#mainWrapper").toggleClass("active");
		if (/terminal/.test(window.location.href)) {
			$("#sidebar-wrapper").toggleClass("active");
		}
		$(this).toggleClass('open');

	});

	function listenInputOpen() {

		bettingButton.onclick = function() {
			coinInput.classList.remove('hide-input');
			coinInput.classList.add('show-input');
			overlay.style.display = 'block';
			bettingButton.style.display = 'none';
		}

		overlay.onclick = function() {
			coinInput.classList.remove('show-input');
			coinInput.classList.add('hide-input');
			overlay.style.display = 'none';
			bettingButton.style.display = 'flex';
		}

		minimize.onclick = function() {
			coinInput.classList.remove('show-input');
			coinInput.classList.add('hide-input');
			overlay.style.display = 'none';
			bettingButton.style.display = 'flex';
		}
	}

	function listenHistoryOpen() {
		historyButton.onclick = function() {
			coinHistory.classList.remove('hide-history');
			coinHistory.classList.add('show-history');
			overlay2.style.display = 'block';
			historyButton.style.display = 'none';
		}

		overlay2.onclick = function() {
			coinHistory.classList.remove('show-history');
			coinHistory.classList.add('hide-history');
			overlay2.style.display = 'none';
			historyButton.style.display = 'flex';
		}
	}

	document.getElementById('fastCoinContainer').style.display = 'flex';

	let cards = document.querySelectorAll('.coins-card');

	listenInputOpen();
	listenHistoryOpen();
	if (window.innerWidth > 1199) {
		checkCardsLength();
	} else {
		checkMediumLength();
	}

	window.onresize = () => {
		setTableFont();
		if (window.innerWidth > 1199) {
			checkCardsLength();
		} else if (window.innerWidth > 959 && window.innerWidth < 1200) {
			checkMediumLength();
		} else {
			checkMediumLength();
		}
	};

	/**
	 * Simulates remove cards from cards table.
	 * 
	 * @param {*} cards 
	 */
	function simulateRemove(cards) {
		cards.forEach((el) => {
			el.onclick = () => {
				el.remove();
				if (window.innerWidth > 1199) {
					checkCardsLength();
				} else {
					checkMediumLength();
				}
			} 
		})
	}
}



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/js/layout.js
// module id = 367
// module chunks = 5